import { render, staticRenderFns } from "./ServicesPaymentsTable.vue?vue&type=template&id=11ac769e&"
import script from "./ServicesPaymentsTable.vue?vue&type=script&lang=js&"
export * from "./ServicesPaymentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports